module.exports = __webpack_public_path__ + "static/media/thumbnail.5151e6b5.jpg";